import React from 'react'
import { Card } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { WorldMap } from '../../widgets/components/General/WorldMap'

const CaptableManagementMap = ({ title, countryCounts }: { title: string; countryCounts: any }) => {
  const { formatMessage } = useIntl() // eslint-disable-next-line

  return (
    <div className='d-flex w-100'>
      <Card
        className='w-75 p-8 pt-4 px-4 bg-white'
        style={{ borderBottomRightRadius: '0px', borderTopRightRadius: '0px' }}
      >
        <p className='mb-0 text-muted'>{formatMessage({ id: title })}</p>
        <div>
          <div className='bg-transparent p-md-8 rounded-2 mb-md-4'>
            <div className='mt-md-n8'>
              <WorldMap dashboardCounts={countryCounts} />
            </div>
          </div>
        </div>
      </Card>
      <Card
        className='w-25 d-flex justify-content-center bg-white'
        style={{ borderBottomLeftRadius: '0px', borderTopLeftRadius: '0px' }}
      >
        <div className='d-flex flex-row align-items-center justify-content-between mt-3'>
          <div className=''>
            <div className='d-flex justify-content-between align-items-center font-size-8 mb-1 gap-12'>
              <span>🔵{formatMessage({ id: 'India' })}</span>
              <span>{countryCounts.countriesCount.indianCountryCount}</span>
            </div>
            <div className='d-flex justify-content-between font-size-8 mb-1'>
              <span>
                <span className='strong-blue-circle me-1'></span> {formatMessage({ id: 'Non-India' })}
              </span>
              <span>{countryCounts.countriesCount.totalOtherCountriesCount}</span>
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}

export default CaptableManagementMap
